var _defs, _g, _g2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 236.84 154.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .Custcls-1, .Custcls-2 {\n        fill: #fff;\n      }\n\n      .Custcls-3, .Custcls-4 {\n        fill: none;\n      }\n\n      .Custcls-3, .Custcls-4, .Custcls-2 {\n        stroke: #000;\n      }\n\n      .Custcls-3, .Custcls-2 {\n        stroke-miterlimit: 10;\n      }\n\n      .Custcls-4 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_16",
    "data-name": "Layer 16"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "Custcls-1",
    x: 21.22,
    y: 20.63,
    width: 215.12,
    height: 133.38,
    rx: 5,
    ry: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "Custcls-3",
    x: 21.22,
    y: 20.63,
    width: 215.12,
    height: 133.38,
    rx: 5,
    ry: 5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "Custcls-2",
    cx: 20.63,
    cy: 20.63,
    r: 20.13
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_101",
    "data-name": "Layer 101"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Custcls-4",
    d: "M129.2,136.03c-26.9,0-48.7-21.8-48.7-48.7s21.8-48.7,48.7-48.7,48.7,21.8,48.7,48.7c0,8.97-7.27,16.23-16.23,16.23h-3.25c-2.01,0-3.02,0-3.86,.13-4.63,.73-8.26,4.37-9,9-.13,.84-.13,1.85-.13,3.86v3.25c0,8.97-7.27,16.23-16.23,16.23Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "Custcls-4",
    cx: 104.85,
    cy: 84.62,
    r: 8.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "Custcls-4",
    cx: 121.08,
    cy: 62.97,
    r: 8.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "Custcls-4",
    cx: 148.14,
    cy: 68.39,
    r: 8.07
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustom);
export default __webpack_public_path__ + "static/media/Custom.5450961a9350f2b203adf68a8d04fc28.svg";
export { ForwardRef as ReactComponent };